export default "__VITE_ASSET__D653lEfi__"